// ==============================
// FINAL UPSSELL LOGIC (CORRECT)
// ==============================

let upsellActive = false;
let skipNextUpsell = false;
let triggeredByAddToCart = false; // ✅ NEW
let openedFromShopNow = false;

// ==============================
// GET CART COUNT
// ==============================
async function getCartCount() {
  try {
    const res = await fetch('/cart.js', { cache: 'no-store' });
    const cart = await res.json();
    return cart.item_count;
  } catch (e) {
    return 0;
  }
}


// ==============================
// POPUP CONTROL
// ==============================
function openUpsellPopup() {
  const popup = document.getElementById('upsell-popup');

  if (popup) {
    upsellActive = true;

    document.body.classList.add('upsell-active');
    popup.classList.add('active');
    document.body.style.overflow = 'hidden';
    popup.style.display = 'flex';
  }
}

function openYMMPopup() {

  const popup = document.getElementById('upsell-popup');

  if (!popup) return;

  openedFromShopNow = true;

  popup.classList.add('ymm-mode');

  // CHANGE TEXT
  const title = popup.querySelector('.upsell-title');

  if (title) {
    title.innerHTML = 'Find Your Screen Protector';
  }

  const offer = popup.querySelector('.upsell-offer');

  if (offer) {
    offer.innerHTML = 'Search from 1000+ vehicle-specific screen protectors';
  }

  // HIDE ELEMENTS
  popup.querySelector('.upsell-success')?.style.setProperty('display', 'none');
  popup.querySelector('.upsell-benefits')?.style.setProperty('display', 'none');
  popup.querySelector('.upsell-note')?.style.setProperty('display', 'none');
  popup.querySelector('.upsell-primary')?.style.setProperty('display', 'none');
  popup.querySelector('.upsell-secondary')?.style.setProperty('display', 'none');
popup.querySelector('#gf-form h2')?.remove();
const style = document.createElement('style');

style.innerHTML = `
  body.upsell-active #gf-form:before {
    display: none !important;
    content: none !important;
  }
`;

document.head.appendChild(style);  // OPEN
  document.body.classList.add('upsell-active');

  popup.classList.add('active');

  document.body.style.overflow = 'hidden';

  popup.style.display = 'flex';
}

// ==============================
// CLOSE POPUP → OPEN DRAWER
// ==============================
function closeUpsellPopup() {
  const popup = document.getElementById('upsell-popup');


  // RESET YMM MODE
if (openedFromShopNow) {

  openedFromShopNow = false;

  popup.classList.remove('ymm-mode');

  // RESET TEXT
  const title = popup.querySelector('.upsell-title');

  if (title) {
    title.innerHTML = 'Protect your second car too?';
  }

  const offer = popup.querySelector('.upsell-offer');

  if (offer) {
    offer.innerHTML = `
      Add one more from below to get <strong>30% off</strong><br>
      <span class="upsell-note">
        Discount applied automatically at checkout
      </span>
    `;
  }

  // SHOW ELEMENTS AGAIN
  popup.querySelector('.upsell-success')?.style.removeProperty('display');
  popup.querySelector('.upsell-benefits')?.style.removeProperty('display');
  popup.querySelector('.upsell-primary')?.style.removeProperty('display');
  popup.querySelector('.upsell-secondary')?.style.removeProperty('display');

}


  const drawer = document.querySelector('cart-drawer-component');
  popup.style.display = 'none';
  if (popup) {
    popup.classList.remove('active');
    document.body.classList.remove('upsell-active');
    document.body.style.overflow = '';
  }

  upsellActive = false;
  skipNextUpsell = true;

  if (drawer) {
    drawer.setAttribute('auto-open', '');

    if (typeof drawer.open === 'function') {
      drawer.open();
    }
  } else {
    window.location.href = '/cart';
  }
}

// ==============================
// ADD TO CART → THEN UPSELL
// ==============================

document.addEventListener('click', function (e) {
  const button = e.target.closest('button[name="add"]');

  if (!button) return;

  // Mark that this cart addition should trigger the upsell
  triggeredByAddToCart = true;

  console.log('ADD TO CART CLICKED');
}, true);


// ==============================
// WHEN CART DRAWER CLOSES
// ==============================

document.addEventListener('click', function (e) {
  const closeButton = e.target.closest(
    'cart-drawer-component button[aria-label*="Close"], cart-drawer-component .close'
  );

  if (!closeButton) return;

  if (!triggeredByAddToCart) return;

  triggeredByAddToCart = false;

  setTimeout(async function () {

    const cartCount = await getCartCount();

    // Don't show upsell if cart has more than 1 item
    if (cartCount > 1) {
      return;
    }

    // Show upsell only when cart has 1 item
    openUpsellPopup();

  }, 300);
});